module.exports = __webpack_public_path__ + "img/blacklogo.77413a8d.png";